import * as React from "react";
import Style from "../../_data/models/Style";
import Meta from "../../_data/models/Meta";
import MyStylesGalleryImageComponent from "./MyStylesGalleryImageComponent";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import {OrderedMap, Iterable} from "immutable";
import ReduxInfiniteScroll from 'redux-infinite-scroll';

interface Props {
    items: OrderedMap<number, Style>;
    meta: Meta;
    loading: boolean;
    loadMore: (meta: Meta) => void;
    errors: string[];
}

const MyStylesGalleryComponent = (props: Props) => {
    let {items, loading, loadMore, meta} = props;        
    let count = 0;

    return (
        <div className="featured-image-block-grid">   
            <ReduxInfiniteScroll
                holderType="div"
                className="row large-up-3 small-up-1"
                loadMore={() => loadMore(meta)}
                elementIsScrollable={false}
                loadingMore={loading}
                showLoader={false}
                threshold={100}>
                {
                    items.toArray().map((item) => {                        
                        return <MyStylesGalleryImageComponent item={item} key={count++}/>
                    })
                }
            </ReduxInfiniteScroll>                          
        </div>
    );
};

export default MyStylesGalleryComponent;


// WEBPACK FOOTER //
// ./app/client/style/components/MyStylesGalleryComponent.tsx